import React, { Component } from 'react';
import { Button, FormGroup } from 'reactstrap';
import Select from 'react-select';
import { FormLabel } from '../forms/FormElements';

export default class DataGridMultiSelectFilter extends Component {
    constructor(props) {
        super(props);
        this.selectRef = React.createRef();
        this.state = {
            selectedValues: [],
            appliedValues: [],
        };
    }

    onChange = (selection) => {
        this.setState({ selectedValues: selection ?? [] });
    };

    selectAll = () => {
        this.setState({ selectedValues: [...(this.props.options ?? [])] });
    };

    apply = () => {
        this.setState(
            (prev) => ({ appliedValues: prev.selectedValues }),
            () => {
                this.props.filterChangedCallback();
                if (this.props.api?.hidePopupMenu) this.props.api.hidePopupMenu();
            },
        );
    };

    getModel() {
        const { appliedValues } = this.state;
        if (!appliedValues.length) return null;
        return { value: appliedValues.map((v) => v[this.props.optionsValue]) };
    }

    setModel(model) {
        const rawValues = model?.value ?? [];
        const restored = (this.props.options ?? []).filter((o) =>
            rawValues.includes(o[this.props.optionsValue]),
        );
        this.setState(
            { selectedValues: restored, appliedValues: restored },
            () => this.props.filterChangedCallback(),
        );
    }

    afterGuiAttached() {
        this.setState((prev) => ({ selectedValues: prev.appliedValues }));
        this.focus();
    }

    focus() {
        window.setTimeout(() => {
            const container = this.selectRef.current;
            if (container) container.focus();
        });
    }

    isFilterActive = () => this.state.appliedValues.length > 0;

    doesFilterPass = (params) => {
        if (!this.isFilterActive()) return true;
        const applied = this.state.appliedValues.map((v) => v[this.props.optionsValue]);
        const field = this.props.colDef?.field;
        const cellValue = field ? params.data?.[field] : undefined;
        if (Array.isArray(cellValue)) return cellValue.some((v) => applied.includes(v));
        return applied.includes(cellValue);
    };

    render() {
        const { selectedValues } = this.state;
        return (
            <FormGroup
                className="p-2 mb-0"
                style={{ width: '300px' }}
            >
                <FormLabel label={this.props.labelText} />
                <div className="d-flex mb-2">
                    <Button
                        size="sm"
                        color="link"
                        className="p-0"
                        onClick={this.selectAll}
                    >
                        Select all
                    </Button>
                </div>
                <Select
                    styles={{
                        valueContainer: (provided) => ({
                            ...provided,
                            maxHeight: '120px',
                            overflowY: 'auto',
                        }),
                    }}
                    isMulti
                    isClearable
                    ref={this.selectRef}
                    value={selectedValues}
                    options={this.props.options}
                    getOptionLabel={(option) => option[this.props.optionsLabel]}
                    getOptionValue={(option) => option[this.props.optionsValue]}
                    onChange={this.onChange}
                />
                <div className="d-flex justify-content-end mt-2">
                    <Button
                        size="sm"
                        color="primary"
                        onClick={this.apply}
                    >
                        Confirm
                    </Button>
                </div>
            </FormGroup>
        );
    }
}
